import React from 'react';

const COLUMNS = [
  { field: 'lastpaid', label: 'Last Reward', align: 'left' },
  { field: 'addr', label: 'Address', align: 'left' },
  { field: 'tier', label: 'Collateral', align: 'right' },
  { field: 'rewards', label: 'Daily Rewards', align: 'right' },
  { field: 'frequency', label: 'Frequency', align: 'left' },
  { field: 'activetime', label: 'Active Time', align: 'left' },
  { field: 'rank', label: 'Rank', align: 'left' }
] as const;

export default function MasternodeListHeader() {
  return (
    <tr className="border-b border-green-500/10">
      {COLUMNS.map(({ field, label, align }) => (
        <th 
          key={field}
          className={`px-6 py-4 text-${align} text-sm font-semibold text-gray-400`}
        >
          {label}
        </th>
      ))}
    </tr>
  );
}